import React, { type FC } from "react";
import { KatIcon } from "@amzn/katal-react";

interface CheckedIconProps {
  isVisible: boolean;
}

const CheckedIcon: FC<CheckedIconProps> = ({ isVisible }) => {
  return (
    <div
      style={{
        visibility: isVisible ? "visible" : "hidden",
      }}
    >
      <KatIcon name="check" size="small" />
    </div>
  );
};

export default CheckedIcon;
